import _extends from "@babel/runtime/helpers/extends";import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";import _slicedToArray from "@babel/runtime/helpers/slicedToArray";var _excluded = ["assetID"];import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ContentfulClient } from '../Contentful';

/** @param {string} assetID */
export function useContentfulImage(assetID) {var _contentfulResponse$f, _contentfulResponse$f2, _contentfulResponse$f3;
  var initialState = /** @type {import('../Contentful/Contentful.types').Asset}*/{};

  var _useState = useState(initialState),_useState2 = _slicedToArray(_useState, 2),contentfulResponse = _useState2[0],setContentfulResponse = _useState2[1];

  useEffect(function () {
    if (contentfulResponse === initialState) {
      ContentfulClient.getAsset(assetID).then(setContentfulResponse);
    }
  }, [assetID, contentfulResponse, initialState]);

  return {
    imageSrc: (_contentfulResponse$f = contentfulResponse.fields) === null || _contentfulResponse$f === void 0 ? void 0 : _contentfulResponse$f.file.url,
    url: (_contentfulResponse$f2 = contentfulResponse.fields) === null || _contentfulResponse$f2 === void 0 ? void 0 : _contentfulResponse$f2.description,
    alt: (_contentfulResponse$f3 = contentfulResponse.fields) === null || _contentfulResponse$f3 === void 0 ? void 0 : _contentfulResponse$f3.title,
    loaded: contentfulResponse !== initialState
  };
}

export var AnchorLink = styled.a.withConfig({ displayName: "ContentfulLinkedImage__AnchorLink", componentId: "sc-16mmv88-0" })([""]);

/**
 * @typedef ContentfulLinkedImageBodyProps
 * @property {string} assetID The Contentful assetID which should contain an image and destination url
 */

/** @type {(props: ContentfulLinkedImageBodyProps & React.HTMLAttributes<HTMLAnchorElement>) => JSX.Element} */
export function ContentfulLinkedImage(props) {
  var
    assetID =

    props.assetID,otherProps = _objectWithoutProperties(props, _excluded);

  var _useContentfulImage = useContentfulImage(assetID),imageSrc = _useContentfulImage.imageSrc,url = _useContentfulImage.url,alt = _useContentfulImage.alt,loaded = _useContentfulImage.loaded;

  if (loaded) {
    return /*#__PURE__*/(
      React.createElement(AnchorLink, _extends({
        href: url },
      otherProps), /*#__PURE__*/

      React.createElement("img", {
        alt: alt,
        src: imageSrc }
      )
      ));

  }

  return /*#__PURE__*/React.createElement(AnchorLink, null, alt);
}
//# sourceMappingURL=ContentfulLinkedImage.js.map